import { Navigate } from 'react-router-dom';

/** Links antigos para /merchant/first-access passam a usar só /merchant (popup é exibido pelo guard). */
const MerchantFirstAccess = () => <Navigate to="/merchant" replace />;

export default MerchantFirstAccess;
